import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormGroup, FormSelect } from "react-bootstrap";
import { injectIntl } from "react-intl";

/**
 *Component which represents a modal of question to library
 */
class QuestionStructureSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actionFieldResults: []
    };
  }

  componentDidMount() {
    if (this.props.selectedActionFieldId) {
      // for loading results of action field
      this.handleActionFieldChange(this.props.selectedActionFieldId);
      this.handleResultChange(this.props.selectedResultId);
    }
  }

  handleActionFieldChange = (actionFieldId) => {
    const { actionFields, results, onActionFieldChange, onResultChange } = this.props;

    const actionFieldResults = results.filter((result) => {
      const actionFieldsIds = result.actionFields.map((af) => af.id);

      return actionFieldsIds.includes(actionFieldId);
    });

    this.setState({
      actionFieldResults: actionFieldResults
    });

    const actionField = actionFields.find((af) => af.id === actionFieldId);

    onActionFieldChange && onActionFieldChange(actionField);
    onResultChange && onResultChange(undefined);
  };

  handleResultChange = (resultId) => {
    const { results, onResultChange } = this.props;

    const result = results.find((r) => r.id === resultId);

    onResultChange && onResultChange(result);
  };

  render() {
    const { intl, actionFields, selectedActionFieldId, selectedResultId, locale } = this.props;

    const { actionFieldResults } = this.state;

    return (
      <FormGroup  className="mb-3">
        <FormSelect
          className="inline"
          placeholder={intl.formatMessage({ id: "indicator.management.action.field" })}
          onChange={(event) => this.handleActionFieldChange(event.target.value)}
          value={selectedActionFieldId}
          name={"actionField"}
        >
          <option value={""}>{intl.formatMessage({ id: "indicator.management.all.action.fields" })}</option>
          {actionFields.map((actionField) => (
            <option key={"af" + actionField.id} value={actionField.id}>
              {actionField.name[locale]}
            </option>
          ))}
        </FormSelect>
        <FormSelect
          className="inline"
          placeholder={intl.formatMessage({ id: "indicator.management.result" })}
          onChange={(event) => this.handleResultChange(event.target.value)}
          value={selectedResultId}
          disabled={!selectedActionFieldId}
          name="result"
        >
          <option value="">{intl.formatMessage({ id: "indicator.management.all.results" })}</option>
          {actionFieldResults.map((result) => (
            <option key={"r" + result.id} value={result.id}>
              {result.name[locale]}
            </option>
          ))}
        </FormSelect>
      </FormGroup>
    );
  }
}

QuestionStructureSelect.propTypes = {
  actionFields: PropTypes.array,
  results: PropTypes.array,
  selectedActionFieldId: PropTypes.string,
  selectedResultId: PropTypes.string,
  locale: PropTypes.string.isRequired,

  onActionFieldChange: PropTypes.func,
  onResultChange: PropTypes.func
};

export default injectIntl(QuestionStructureSelect);
